<!-- MODAL Agregar -->
<div mdbModal #agregarMovimiento="mdb-modal" class="modal fade" style="overflow-y: auto" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Movimiento de inventario</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formHeader">
          <div class="row align-items-center tipoMovimiento">
            <div class="col dato" style="max-width: 200px">
              <Strong class="title">Fecha de movimiento</Strong>
              <!-- <span class="value">15/02/2020</span> -->
              <mdb-date-picker [inline]="true" name="fechaMov" placeholder="Fecha Movimiento" required
                formControlName="fechaMovimiento" disabled></mdb-date-picker>
            </div>

            <div class="col" style="max-width: 200px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsTipoMovimiento" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar" formControlName="tipoMovimiento"></mdb-select>
                <label>Tipo de Movimiento</label>
                <div
                  *ngIf="formHeader.get('tipoMovimiento').invalid && (formHeader.get('tipoMovimiento').dirty || formHeader.get('tipoMovimiento').touched)">
                  <mdb-error *ngIf="formHeader.get('tipoMovimiento').hasError('required')">Ingrese tipo de movimiento
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="max-width: 350px">
              <mdb-checkbox formControlName="ingresoDocElectronico">Ingreso de Documento Electrónico</mdb-checkbox>
            </div>

            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <input value="" type="text" id="referencia" class="form-control" placeholder="Referencia" required
                  #referencia formControlName="referencia" />
                <label for="rutcliente">Referencia</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col" style="max-width: 300px" *ngIf="showBodegaSalida">
              <div class="md-form">
                <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Bodega" formControlName="bodegaSalida"></mdb-select>
                <label>Bodega Salida</label>
                <ng-container ngif="showBodegaSalida">
                  <div
                    *ngIf="formHeader.get('bodegaSalida').invalid && (formHeader.get('bodegaSalida').dirty || formHeader.get('bodegaSalida').touched)">
                    <mdb-error *ngIf="formHeader.get('bodegaSalida').hasError('required')">Ingrese bodega salida
                    </mdb-error>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="col" style="max-width: 300px" *ngIf="showBodegaEntrada">
              <div class="md-form">
                <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Bodega" formControlName="bodegaEntrada"></mdb-select>
                <label>Bodega Entrada</label>
                <div
                  *ngIf="formHeader.get('bodegaEntrada').invalid && (formHeader.get('bodegaEntrada').dirty || formHeader.get('bodegaEntrada').touched)">
                  <mdb-error *ngIf="formHeader.get('bodegaEntrada').hasError('required')">Ingrese bodega ingreso
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row align-items-center tipoMovimiento" *ngIf="formHeader.get('ingresoDocElectronico').value">
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <mdb-select [options]="optionsTipDocumento" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar Tipo de Documento" formControlName="tipoDocumento">
                </mdb-select>
                <label>Tipo de Documento</label>
                <mdb-error *ngIf="formHeader.get('tipoDocumento').hasError('required')">Ingrese tipo de documento
                </mdb-error>
              </div>
            </div>

            <div class="col" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" id="nroDoc" class="form-control" placeholder="0000" required #nroDoc
                  formControlName="numeroDocumento" onlyNumbers />
                <label for="nroDoc">Nro. Documento</label>
                <mdb-error *ngIf="formHeader.get('numeroDocumento').hasError('required')">Ingrese nro. documento
                </mdb-error>
              </div>
            </div>
          </div>
        </form>

        <form [formGroup]="formDetails" novalidate>
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">Ingreso de productos</h5>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="codProduct" class="form-control" placeholder="" required #codProduct
                  formControlName="codigo" />
                <label for="codProduct">Código de producto</label>
                <div
                  *ngIf="formDetails.get('codigo').invalid && (formDetails.get('codigo').dirty || formDetails.get('codigo').touched)">
                  <mdb-error *ngIf="formDetails.get('codigo').hasError('required')">Ingrese código de producto
                  </mdb-error>
                  <mdb-error *ngIf="formDetails.get('codigo').hasError('min')"> Código de producto debe ser mayor a 0
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col d-flex">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionarProducto()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" *ngIf="productoSeleccionado" style="display: contents">
                {{ productoSeleccionado.descripcion }}
              </h6>
            </div>
            <div class="col dato">
              <div class="md-form">
                <mdb-select [options]="optionsFormato" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
                <label>Formato</label>
                <div
                  *ngIf="formDetails.get('formato').invalid && (formDetails.get('formato').dirty || formDetails.get('formato').touched)">
                  <mdb-error *ngIf="formDetails.get('formato').hasError('required')">Ingrese formato </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                  formControlName="cantidad" monto />
                <label for="cant">Cantidad</label>
                <div
                  *ngIf="formDetails.get('cantidad').invalid && (formDetails.get('cantidad').dirty || formDetails.get('cantidad').touched)">
                  <mdb-error *ngIf="formDetails.get('cantidad').hasError('required')">Ingrese cantidad </mdb-error>
                  <mdb-error *ngIf="formDetails.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col">
              <button size="sm" class="btn btn-sm" type="button" mdbBtn color="info" mdbWavesEffect
                (click)="validarExistenciaYAgregar()">Agregar</button>
            </div>
          </div>
        </form>

        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
              </th>
              <th scope="col">SKU</th>
              <th scope="col">Producto</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-center">Cantidad</th>
              <th scope="col" class="text-right">Costo Unitario</th>
              <th scope="col" class="text-right">Costo total</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <tr *ngFor="let mov of listaMovimientos">
              <td>
                <mdb-checkbox [checked]="mov.additionalInfo.checked"
                  (change)="checkMovimiento(mov.additionalInfo, $event)"> </mdb-checkbox>
              </td>
              <td>{{ mov.sku }}</td>
              <td>{{ mov.producto_descripcion }}</td>
              <td>{{ mov.formato_nombre }}</td>
              <td class="text-center">{{ mov.cantidad | numerico }}</td>
              <td class="text-right">{{ mov.precio_costo | numerico }}</td>
              <td class="text-right">{{ mov.additionalInfo.costoTotal | numerico }}</td>
              <td>
                <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                  (click)="eliminarMovimiento(mov)">
                  <mdb-icon fas icon="trash"></mdb-icon>
                </button>
              </td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMovimientos?.length > 0"></app-pagination>

          <tbody class="blue lighten-5" *ngIf="listaMovimientosResumen">
            <tr>
              <td align="right" colspan="4">
                <strong>Total</strong>
              </td>
              <td align="center">
                <strong>{{ listaMovimientosResumen.cantidad | numerico }}</strong>
              </td>
              <td align="right">
                <strong>$ {{ listaMovimientosResumen.subtotal | numerico }}</strong>
              </td>
              <td align="right">
                <strong>$ {{ listaMovimientosResumen.total | numerico }}</strong>
              </td>
              <td align="right"></td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col">
            <button type="button" size="sm" class="btn btn-sm btn-warning waves-light" data-dismiss="modal"
              mdbWavesEffect (click)="eliminarSeleccionados()">Eliminar</button>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal" (click)="hide()"
          mdbWavesEffect>Cerrar</button>
        <div class="">
          <button size="sm" type="button" class="btn btn-sm btn-success waves-light" mdbWavesEffect
            (click)="print()">Imprimir</button>
            <app-api-button (click2)="guardar()" [disabled]="listaMovimientos?.length === 0" [processing]="processing">Guardar </app-api-button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()" (onRemoteQuery)="getProducts($event)"></app-modal-seleccionar-producto>
